<template>
    <vx-card :title="fullName">
        <template slot="actions">
            <div class="profile-img-container">
                <user-avatar
                    class="user-avatar"
                    :class="{ 'mr-6': !!$slots.actions }"
                    :staff="localGeneralPractitioner"
                />
            </div>
            <slot name="actions"> </slot>
        </template>
        <div class="flex-col items-center">
            Primary Practice
            <practice-link v-if="primaryPractice" :practice="primaryPractice" replace />
        </div>

        <template slot="footer">
            <vx-action-icon
                tooltip="Edit"
                is-button
                icon="Edit1Icon"
                color="warning"
                @click="showEditor = true"
            />
        </template>
        <general-practitioner-editor
            v-model="localGeneralPractitioner"
            :generalPractitioner="localGeneralPractitioner"
            :active.sync="showEditor"
            @updated="updateGeneralPractitionerDetails"
        />
    </vx-card>
</template>

<script>
import { mapGetters } from 'vuex'
import PracticeInfoCard from '../practices/PracticeInfoCard.vue'
import PracticeLink from '../practices/PracticeLink.vue'
import UserChip from '@/views/admin/practices/PracticeChip.vue'
import UserAvatar from '../../../components/project/UserProfiles/UserAvatar.vue'
import GeneralPractitionerForm from './GeneralPractitionerForm.vue'
import GeneralPractitionerEditor from './GeneralPractitionerEditor.vue'

export default {
    name: 'general-practitioner-profile-card',
    components: {
        PracticeInfoCard,
        UserChip,
        PracticeLink,
        UserAvatar,
        GeneralPractitionerForm,
        GeneralPractitionerEditor
    },
    props: {
        generalPractitioner: {
            type: Object,
            required: true
        }
    },
    watch: {},
    data() {
        return {
            localGP: null,
            showProfileEditPrompt: false,
            doNotDistributeText: 'Do not distribute',
            activeTab: 0,
            manageRolePermission: ['SuperUser', 'UserAdmin'],
            alignment: 'top',
            activePrimaryPractice: null,
            selectedPrimaryPractice: null,
            practiceOptions: [],
            showEditor: false
        }
    },
    computed: {
        localGeneralPractitioner: {
            get() {
                if (this.localGP) {
                    return this.localGP
                }
                return this.generalPractitioner
            },
            set(v) {
                this.generalPractitioner = v
            }
        },
        primaryPractice: {
            get() {
                return this.localGeneralPractitioner.primaryPractice || null
            },
            set(v) {
                this.localGeneralPractitioner.primaryPracticeId = v.id
            }
        },

        generalPractitionerId() {
            if (this.generalPractitioner) {
                return this.generalPractitioner.id
            }
        },
        fullName() {
            if (this.loading) {
                return 'Loading...'
            }
            return this.localGeneralPractitioner.name
        },
        ...mapGetters({
            theme: 'user/theme',
            userInfo: 'user/profile',
            getUserById: 'generalPractitioner/getById'
        })
    },
    methods: {
        async updateGeneralPractitionerDetails(updatedGeneralPractitioner) {
            this.localGeneralPractitioner = updatedGeneralPractitioner
            this.$emit('updated', updatedGeneralPractitioner)
        }
    },
    async created() {
        this.practiceOptions = this.$store.getters['maarima/practices']
    }
}
</script>

<style scoped>
.profile-img-container {
    height: 30px;
    width: 30px;
    position: relative;
}
.user-avatar {
    right: 0px;
    top: -35px;
    position: absolute;
    z-index: 500;
}
</style>
